import {xarcadeUser} from '@/_models/User'

interface State{
  authenticated: boolean;
  jwtToken: string;
  mainnetJwtToken: string;
  user: xarcadeUser;
}

interface loginData{
  userData: xarcadeUser;
  jwtToken: string;
}

interface mainnetLoginData{
  userData: xarcadeUser;
  mainnetJwtToken: string;
}

export const auth = {
  namespaced: true,
  state: {
    authenticated: sessionStorage.getItem("authenticated")? JSON.parse(sessionStorage.getItem("authenticated")) : false,
    jwtToken: sessionStorage.getItem("jwtToken")? JSON.parse(sessionStorage.getItem("jwtToken")) : '',
    mainnetJwtToken: sessionStorage.getItem("mainnetJwtToken")? JSON.parse(sessionStorage.getItem("mainnetJwtToken")) : '',
    user: sessionStorage.getItem("userData")? JSON.parse(sessionStorage.getItem("userData")) : {}
  },

  getters: {
    authenticated(state:State):boolean{
      return state.authenticated;
    },

    user(state:State):xarcadeUser{
      return state.user;
    },

    jwtToken(state:State):string{
      return state.jwtToken;
    },

    mainnetJwtToken(state:State):string{
      return state.mainnetJwtToken;
    }
  },

  mutations: {
    SET_AUTHENTICATED (state:State, value:boolean):void{
      sessionStorage.setItem("authenticated", JSON.stringify(value));
      state.authenticated = value;
    },

    SET_USER (state:State, value:xarcadeUser):void{
      sessionStorage.setItem("userData", JSON.stringify(value));
      state.user = value;
    },

    SET_JWTTOKEN(state: State, value: string):void{
      sessionStorage.setItem("jwtToken", JSON.stringify(value));
      state.jwtToken = value;
    },

    SET_MAINNETJWTTOKEN(state: State, value: string):void{
      sessionStorage.setItem("mainnetJwtToken", JSON.stringify(value));
      state.mainnetJwtToken = value;
    },

    REMOVE_AUTHENTICATED(state:State):void{
      sessionStorage.removeItem("authenticated");
      state.jwtToken = '';
      state.mainnetJwtToken = '';
      state.authenticated = false;
    },

    REMOVE_USER (state:State):void{
      sessionStorage.removeItem("userData");
      state.user = null;
    },

    REMOVE_JWTTOKEN (state:State):void{
      sessionStorage.removeItem("jwtToken");
      state.jwtToken = '';
    },

    REMOVE_MAINNETJWTTOKEN (state:State):void{
      sessionStorage.removeItem("mainnetJwtToken");
      state.mainnetJwtToken = '';
    },

    REMOVE_WALLET_ONBOARD ():void{
      sessionStorage.removeItem("closeWalletSetupSession");
    }
  },

  actions: {
    login: ({commit}, data:loginData):void => {
      commit('SET_USER', data.userData);
      commit('SET_JWTTOKEN', data.jwtToken);
      commit('SET_AUTHENTICATED',true);
    },

    mainnetLogin: ({commit}, data:mainnetLoginData):void => {
      commit('SET_USER', data.userData);
      commit('SET_MAINNETJWTTOKEN', data.mainnetJwtToken);
    },

    removeStates: ({commit}):void => {
      commit('REMOVE_USER');
      commit('REMOVE_AUTHENTICATED');
      commit('REMOVE_JWTTOKEN');
      commit('REMOVE_MAINNETJWTTOKEN');
      commit('REMOVE_WALLET_ONBOARD');
    },

    updateUser: ({commit}, data:loginData):void => {
      commit('SET_USER', data.userData);
    }
  }
}

